import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {FreespinRespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinRespinZeroBetController";
import {ThorGameMode} from "../gamemode/ThorGameMode";

/**
 * Created by Jerker Nord on 2019-12-16.
 */

export class ThorNudgeRespinFSZeroBetController extends FreespinRespinZeroBetController {

    constructor() {
        super();
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        if((data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
            || ((<ParsedInitData>data).isRestoreState && data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NORMAL)
            || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
        ) {
            return true;
        } else {
            return false;
        }
    }
}